// Thin wrapper around Chrome's experimental WebMCP API (document.modelContext), which lets a
// page register structured "tools" an AI browser agent can call directly instead of simulating
// clicks/typing. Behind an origin trial as of Chrome 149 — see docs/plans/agentic-readiness.md.
// Calls are no-ops in any browser that doesn't implement the API.

export interface WebMCPTool {
  name: string;
  description: string;
  inputSchema: Record<string, unknown>;
  execute: (args: Record<string, unknown>) => Promise<unknown> | unknown;
  annotations?: { readOnlyHint?: boolean; untrustedContentHint?: boolean };
}

interface ModelContext {
  registerTool: (tool: WebMCPTool, options?: { signal?: AbortSignal }) => void;
}

function getModelContext(): ModelContext | undefined {
  return (document as unknown as { modelContext?: ModelContext }).modelContext;
}

/** Registers a tool for the lifetime of `signal`; silently does nothing if WebMCP isn't supported. */
export function registerWebMCPTool(tool: WebMCPTool, signal: AbortSignal) {
  getModelContext()?.registerTool(tool, { signal });
}
